// import React, { useState, useRef, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.css';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import Header from './Headstu';
// import axios from '../Axiosinstance'
// import { useParams } from 'react-router-dom';
// import { Table, Button, Typography, Box, Paper, Grid, Divider, TableBody, TableRow, TableCell } from '@mui/material';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import { FaTrash } from 'react-icons/fa';
// import { TextField, Select, MenuItem, Modal, IconButton } from '@mui/material';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons'; // Import the specific icon you want to use

// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import { decryptData } from '../Axiosinstance';
// import { batch } from 'react-redux';

// const extractYouTubeVideoId = (url) => {
//   // Extract the video ID from the YouTube URL
//   const videoId = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=|embed\/watch\?feature=player_embedded&v=))([^&\n?#]+)/);
//   return videoId ? videoId[1] : null;
// };

// const Key = () => {
//   // const { id } = useParams();
//   const { id: encodedId } = useParams(); // Get encoded batchId
//   const id = decryptData(decodeURIComponent(encodedId)); // Decode & Decrypt

//   const [modules, setModules] = useState([]);
//   const [selectedModule, setSelectedModule] = useState(null);
//   const [selectedContent, setSelectedContent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [studentData, setStudentData] = useState([]);
//   const [filteredStartModulus, setFilteredStartModulus] = useState([]);
//   const [filteredModules, setFilteredModules] = useState([]);

//   const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

//   useEffect(() => {
//     axios.get(`module-content/batch/${id}`)
//       .then((response) => {
//         setModules(response.data);
//       })
//       .catch((error) => {
//         console.error('Error fetching data: ', error);
//       });
//   }, [id]);

//   useEffect(() => {
//     const fetchBatchIds = async () => {
//       try {
//         const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
//         const studentData1 = response.data[0];
//         setStudentData(studentData1); // First, update state
//         console.log("hida", studentData1);
//       } catch (error) {
//         console.error("Error fetching batch data:", error);
//       }
//     };

//     if (studentTeacherId) {
//       fetchBatchIds();
//     }
//   }, [studentTeacherId]);

//   useEffect(() => {
//     if (studentData?.scheduleDate) {  // Ensure studentData and scheduleDate exist
//       const currentDate = new Date().toISOString().split("T")[0];

//       const firstModuleId = studentData?.scheduleDate[0]?.startModulus;

//       const filteredModulus = studentData?.scheduleDate
//         .filter(item => item.startDate <= currentDate || item.startModulus === firstModuleId)
//         .map(item => item.startModulus);

//       // setFilteredStartModulus(filteredModulus);

//       // Find matching modules based on startModulus
//       const matchedModules = studentData?.batch?.moduleDetails
//         .filter(module => filteredModulus.includes(module.id)) // Match startModulus with module id
//         .map(module => ({
//           id: module.id,
//           moduleName: module.moduleName
//         }));

//       setFilteredStartModulus(matchedModules);
//       console.log("matchedModules", matchedModules)

//       // const filteredModules = modules.filter(module => 
//       //   matchedModules.some(matched => matched.moduleName === module.name)
//       // );
//       // setFilteredModules(filteredModules);

//       const filteredModules = modules.filter(module =>
//         matchedModules.some(matched =>
//           matched.moduleName.trim().toLowerCase() === module.name.trim().toLowerCase()
//         )
//       );
//       setFilteredModules(filteredModules); // ✅ add this line
//     }
//   }, [studentData, modules]); // Runs only when studentData updates



//   // Run once on mount

//   console.log(filteredStartModulus);
//   const handleModuleClick = (module) => {
//     console.log("module", module);
//     setSelectedModule(module);
//     setSelectedContent(null); // Reset selected content when switching modules
//   };

//   // const handleContentClick = (content) => {
//   //   setSelectedContent(content);
//   // };

//   const modalHeaderName = "Couse ";


//   const handleContentClick = (file) => {
//     setSelectedContent(file);
//     setIsModalOpen(true); // Open the modal
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedContent(null); // Clear selected content when closing
//   };

//   const renderIframeContent = (content) => {
//     switch (content.type) {
//       case 'pdf': // PDF files
//         return (
//           <iframe
//             src={content.fileUrl}
//             style={{ width: '100%', height: '100%' }}
//             title="PDF Viewer"
//           ></iframe>
//         );
//       case 'ppt': // PowerPoint files
//         return (
//           <iframe
//             src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(content.fileUrl)}`}
//             style={{ width: '100%', height: '100%' }}
//             title="PowerPoint Viewer"
//           ></iframe>
//         );
//       case 'video': // Video files
//         return (
//           <video width="100%" height="auto" controls>
//             <source src={content.fileUrl} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
//         );
//       case 'youtube link': // YouTube links
//         return (
//           <iframe
//             src={content.fileUrl.replace("youtu.be", "www.youtube.com/embed").split("?")[0]} // Convert to embeddable format
//             style={{ width: '100%', height: '100%' }}
//             title="YouTube Video"
//             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//             allowFullScreen
//           ></iframe>
//         );
//       case 'text': // Plain text or HTML content
//         return (
//           <div
//             style={{
//               padding: '10px',
//               fontFamily: 'monospace',
//               whiteSpace: 'pre-wrap',
//             }}
//             dangerouslySetInnerHTML={{ __html: content.fileUrl }}
//           ></div>
//         );
//       default: // Unsupported formats
//         return (
//           <div style={{ textAlign: 'center', padding: '20px' }}>
//             <p style={{ color: 'red', fontWeight: 'bold' }}>
//               Unsupported format: {content.type}
//             </p>
//           </div>
//         );
//     }
//   };

//   return (
//     <div style={{ padding: '20px' }}>
//       <Paper
//         elevation={4}
//         style={{
//           padding: '20px',
//           borderRadius: '15px',
//           background: '#ffffff',
//           maxWidth: '1000px',
//           margin: '0 auto',
//         }}
//       >
//         <Typography
//           variant="h4"
//           style={{
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             color: '#333',
//             textAlign: 'center',
//           }}
//         >
//           <FontAwesomeIcon
//             icon={faFilePowerpoint}
//             style={{ marginRight: '10px', color: '#3f51b5' }}
//           />
//           Course Content
//         </Typography>

//         {/* Module List */}
//         <Box p={2} style={{ background: '#f0f4f8', borderRadius: '8px', marginBottom: '20px' }}>
//           <Typography variant="h5" style={{ color: '#555', fontWeight: 'bolder' }}>
//             Module Lists
//           </Typography>

//           <Divider />
//           <br />
//           <Box
//             display="grid"
//             gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
//             gap="16px"
//           >
//             {filteredModules?.map((module) => (
//               <Button
//                 key={module.id}
//                 variant="contained"
//                 color="primary"
//                 style={{
//                   height: "50px",
//                   textTransform: "none",
//                   fontSize: "15px",
//                   minWidth: "200px",
//                   width: "100%", // Ensures buttons take full width of their grid cell
//                 }}
//                 onClick={() => handleModuleClick(module)}
//               >
//                 {module.name}
//               </Button>
//             ))}
//           </Box>
//         </Box>

//         {/* Content List */}
//         <Box p={2} style={{ background: '#f0f4f8', borderRadius: '8px', marginBottom: '20px' }}>
//           <Typography variant="h5" style={{ marginBottom: '10px', color: '#555', fontWeight: 'bolder' }}>
//             Module Content
//           </Typography>
//           <Divider />
//           <br />
//           <Table>
//             <TableBody>
//               {selectedModule?.files.map((file) => (
//                 <TableRow
//                   key={file.id}
//                   onClick={() => handleContentClick(file)}
//                   style={{
//                     cursor: 'pointer',
//                     backgroundColor: selectedContent?.id === file.id ? '#e3f2fd' : 'transparent',
//                     transition: 'background 0.3s',
//                     borderRadius: '8px',
//                   }}
//                 >
//                   <TableCell style={{ fontSize: '18px', fontWeight: '800', padding: '12px' }}>
//                     {file.fileName}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Box>
//       </Paper>

//       {/* Modal for Full-Container View */}
//       <Modal open={isModalOpen} onClose={handleCloseModal}>
//         <Box
//           style={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             background: '#ffffff',
//             borderRadius: '15px',
//             padding: '20px',
//             width: '90%',
//             height: '90%',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//             overflow: 'auto',
//           }}
//         >
//           <IconButton
//             onClick={handleCloseModal}
//             style={{ position: 'absolute', top: '10px', right: '10px' }}
//           >
//             <FontAwesomeIcon icon={faTimes} />
//           </IconButton>
//           {/* Modal Header */}
//           <Typography
//             variant="h6"
//             component="h2"
//             style={{
//               marginBottom: "20px",
//               fontWeight: "bold",
//               textAlign: "center",
//             }}
//           >
//             {selectedContent?.fileName}
//           </Typography>
//           {selectedContent && renderIframeContent(selectedContent)}
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// // export default Key;

// const Managec = () => {
//   return (
//     <div >
//       <Header />

//       <Key />
//     </div>
//   );
// };

// export default Managec;

// function renderDownloadButton(content, type) {
//   // Check if the content type is not a YouTube link and type is defined
//   if (type && type !== 'youtube') {
//     return (
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={() => handleDownload(content.fileUrl, type)}>
//         Download {type.toUpperCase()}
//       </Button>
//     );
//   }

//   // No download button for YouTube links or if type is undefined
//   return null;
// }

// function handleDownload(fileUrl, type) {
//   // Implement download logic here
//   if (type === 'text') {
//     downloadTextFile(fileUrl, 'download.txt');
//   } else if (type === 'pdf' || type === 'ppt') {
//     downloadFile(fileUrl, `download.${type}`);
//   } else {
//     window.location.href = fileUrl; // This is a simple example; improve based on your requirements
//   }
// }


// function downloadTextFile(htmlContent, fileName) {
//   const element = document.createElement('a');

//   // Convert HTML content to formatted plain text
//   const plainTextContent = convertHtmlToPlainText(htmlContent);

//   const file = new Blob([plainTextContent], { type: 'text/plain' });

//   element.href = URL.createObjectURL(file);
//   element.download = fileName;
//   document.body.appendChild(element);
//   element.click();
// }

// function convertHtmlToPlainText(htmlContent) {
//   const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
//   const textContent = doc.body.textContent || '';
//   return decodeHtmlEntities(textContent);
// }

// function decodeHtmlEntities(text) {
//   const element = document.createElement('div');
//   element.innerHTML = text;
//   return element.innerText;
// }

// function downloadFile(fileUrl, fileName) {
//   fetch(fileUrl)
//     .then(response => response.blob())
//     .then(blob => {
//       const element = document.createElement('a');
//       const file = new Blob([blob], { type: 'application/octet-stream' });

//       element.href = URL.createObjectURL(file);
//       element.download = fileName;
//       document.body.appendChild(element);
//       element.click();
//     })
//     .catch(error => {
//       console.error('Error downloading file:', error);
//     });
// }

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../Axiosinstance';
import { decryptData } from '../Axiosinstance';
import Header from './Headstu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePowerpoint, faTimes, faBook, faFileAlt, faVideo, faLink, faFilePdf, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// ─── Styled Components ──────────────────────────────────────────────────────

const PageWrapper = styled(Box)({
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  padding: '32px 16px',
});

const StyledPaper = styled(Paper)({
  padding: '32px',
  borderRadius: '20px',
  background: '#ffffff',
  maxWidth: '1100px',
  margin: '0 auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
});

const SectionBox = styled(Box)({
  background: '#f8faff',
  borderRadius: '12px',
  padding: '24px',
  marginBottom: '24px',
  border: '1px solid #e8edf5',
});

const ModuleButton = styled(Button)(({ selected }) => ({
  height: '56px',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '10px',
  width: '100%',
  transition: 'all 0.25s ease',
  background: selected ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#ffffff',
  color: selected ? '#ffffff' : '#555',
  border: selected ? 'none' : '2px solid #e0e7ff',
  boxShadow: selected ? '0 8px 20px rgba(102,126,234,0.4)' : '0 2px 8px rgba(0,0,0,0.06)',
  '&:hover': {
    background: selected
      ? 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)'
      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#ffffff',
    border: 'none',
    boxShadow: '0 8px 20px rgba(102,126,234,0.4)',
    transform: 'translateY(-2px)',
  },
}));

const ContentRow = styled(TableRow)(({ selected }) => ({
  cursor: 'pointer',
  borderRadius: '10px',
  background: selected ? '#ede9fe' : 'transparent',
  transition: 'background 0.2s',
  '&:hover': {
    background: '#ede9fe',
  },
}));

const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#ffffff',
  borderRadius: '20px',
  padding: '24px',
  width: '92%',
  height: '92%',
  boxShadow: '0 24px 80px rgba(0,0,0,0.3)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

// ─── Helpers ────────────────────────────────────────────────────────────────

const getFileIcon = (type) => {
  switch (type?.toLowerCase()) {
    case 'pdf': return faFilePdf;
    case 'ppt': case 'pptx': return faFilePowerpoint;
    case 'video': return faVideo;
    case 'youtube link': return faLink;
    case 'text': return faFileAlt;
    default: return faBook;
  }
};

const getTypeColor = (type) => {
  switch (type?.toLowerCase()) {
    case 'pdf': return 'error';
    case 'ppt': case 'pptx': return 'warning';
    case 'video': return 'success';
    case 'youtube link': return 'info';
    case 'text': return 'default';
    default: return 'primary';
  }
};

/**
 * Clean a potentially corrupted fileUrl.
 * The API sometimes embeds JSON inside the URL string — strip everything
 * after the actual file extension.
 */
const cleanFileUrl = (url) => {
  if (!url) return '';
  // Cut off at the first '[' or whitespace that signals embedded JSON
  const cutIdx = url.search(/[\[\s]/);
  return cutIdx !== -1 ? url.slice(0, cutIdx) : url;
};

const renderContent = (content) => {
  const url = cleanFileUrl(content.fileUrl);
  const type = content.type?.toLowerCase();

  switch (type) {
    case 'pdf':
      return (
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`}
          style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px' }}
          title="PDF Viewer"
        />
      );

    case 'ppt':
    case 'pptx':
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
          style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px' }}
          title="PowerPoint Viewer"
        />
      );

    case 'video':
      return (
        <video
          style={{ width: '100%', height: '100%', borderRadius: '8px', background: '#000' }}
          controls
          autoPlay={false}
        >
          <source src={url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );

    case 'youtube link': {
      // Support both youtu.be/ID and youtube.com/watch?v=ID
      const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=))([^&\n?#]+)/
      );
      const videoId = match ? match[1] : null;
      if (!videoId) return <Alert severity="error">Invalid YouTube URL.</Alert>;
      return (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px' }}
          title="YouTube Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }

    case 'text':
      return (
        <Box
          sx={{
            padding: '20px',
            fontFamily: 'monospace',
            whiteSpace: 'pre-wrap',
            overflowY: 'auto',
            height: '100%',
            background: '#f8faff',
            borderRadius: '8px',
            fontSize: '15px',
            lineHeight: 1.7,
          }}
          dangerouslySetInnerHTML={{ __html: url }}
        />
      );

    default:
      return (
        <Box sx={{ textAlign: 'center', padding: '40px' }}>
          <Alert severity="warning">
            Unsupported file type: <strong>{content.type}</strong>
          </Alert>
        </Box>
      );
  }
};

// ─── Main Component ──────────────────────────────────────────────────────────

const CourseContentKey = () => {
  const { id: encodedId } = useParams();
  const id = decryptData(decodeURIComponent(encodedId));

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Student-related state (for schedule-based filtering)
  const [studentData, setStudentData] = useState(null);
  const [filteredModules, setFilteredModules] = useState([]);

  const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

  // 1. Fetch all modules for this batch
  useEffect(() => {
    setLoading(true);
    axios
      .get(`module-content/batch/${id}`)
      .then((res) => {
        setModules(res.data || []);
        setError(null);
      })
      .catch((err) => {
        console.error('Error fetching modules:', err);
        setError('Failed to load course content. Please try again.');
      })
      .finally(() => setLoading(false));
  }, [id]);

  // 2. Fetch student registration data (for schedule-based access control)
  useEffect(() => {
    if (!studentTeacherId) return;
    axios
      .get(`registrationadvances/student/${studentTeacherId}/registration-advances`)
      .then((res) => {
        setStudentData(res.data?.[0] || null);
      })
      .catch((err) => console.error('Error fetching student data:', err));
  }, [studentTeacherId]);

  // 3. Filter modules based on schedule dates
  // useEffect(() => {
  //   // If no student schedule data, show ALL modules (no access restriction)
  //   if (!studentData?.scheduleDate || !modules.length) {
  //     setFilteredModules(modules);
  //     return;
  //   }

  //   const currentDate = new Date().toISOString().split('T')[0];
  //   const firstModuleId = studentData.scheduleDate[0]?.startModulus;

  //   // Collect allowed startModulus IDs (started or first module always visible)
  //   const allowedModuleIds = studentData.scheduleDate
  //     .filter((item) => item.startDate <= currentDate || item.startModulus === firstModuleId)
  //     .map((item) => item.startModulus);

  //   // Match module names from batch.moduleDetails
  //   const allowedNames = (studentData.batch?.moduleDetails || [])
  //     .filter((m) => allowedModuleIds.includes(m.id))
  //     .map((m) => m.moduleName.trim().toLowerCase());

  //   // If no name matches found, fall back to showing all modules
  //   if (!allowedNames.length) {
  //     setFilteredModules(modules);
  //     return;
  //   }

  //   const result = modules.filter((m) =>
  //     allowedNames.includes(m.name.trim().toLowerCase())
  //   );

  //   setFilteredModules(result.length ? result : modules); // Always show something
  // }, [studentData, modules]);

  // TEMPORARY: Show all modules
useEffect(() => {
  setFilteredModules(modules);
}, [modules]);

  const handleModuleClick = (module) => {
    setSelectedModule(module);
    setSelectedContent(null);
  };

  const handleContentClick = (file) => {
    setSelectedContent(file);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedContent(null);
  };

  return (
    <PageWrapper>
      <StyledPaper elevation={0}>
        {/* ── Header ── */}
        <Box textAlign="center" mb={4}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
              borderRadius: '16px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              mb: 2,
              boxShadow: '0 8px 24px rgba(102,126,234,0.4)',
            }}
          >
            <FontAwesomeIcon icon={faFilePowerpoint} style={{ fontSize: 28, color: '#fff' }} />
          </Box>
          <Typography variant="h4" fontWeight={800} color="#1a1a2e" letterSpacing="-0.5px">
            Course Content
          </Typography>
          <Typography variant="body1" color="text.secondary" mt={0.5}>
            Select a module to view its materials
          </Typography>
        </Box>

        {/* ── Loading / Error States ── */}
        {loading && (
          <Box textAlign="center" py={6}>
            <CircularProgress size={48} sx={{ color: '#667eea' }} />
            <Typography mt={2} color="text.secondary">Loading modules…</Typography>
          </Box>
        )}

        {!loading && error && (
          <Alert severity="error" sx={{ borderRadius: '10px', mb: 3 }}>{error}</Alert>
        )}

        {!loading && !error && (
          <>
            {/* ── Module List ── */}
            <SectionBox>
              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <Typography variant="h6" fontWeight={700} color="#1a1a2e">
                  Module List
                </Typography>
                <Chip
                  label={`${filteredModules.length} module${filteredModules.length !== 1 ? 's' : ''}`}
                  size="small"
                  sx={{ background: '#ede9fe', color: '#7c3aed', fontWeight: 600 }}
                />
              </Box>
              <Divider sx={{ mb: 2.5 }} />

              {filteredModules.length === 0 ? (
                <Alert severity="info" sx={{ borderRadius: '10px' }}>
                  No modules are available for your current schedule.
                </Alert>
              ) : (
                <Grid container spacing={2}>
                  {filteredModules.map((module) => (
                    <Grid item xs={12} sm={6} md={4} key={module.id}>
                      <ModuleButton
                        selected={selectedModule?.id === module.id ? 1 : 0}
                        onClick={() => handleModuleClick(module)}
                        startIcon={
                          <FontAwesomeIcon
                            icon={faBook}
                            style={{ fontSize: 14 }}
                          />
                        }
                        endIcon={<FontAwesomeIcon icon={faChevronRight} style={{ fontSize: 11 }} />}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            textAlign: 'left',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            mx: 0.5,
                          }}
                        >
                          {module.name}
                        </Box>
                      </ModuleButton>
                    </Grid>
                  ))}
                </Grid>
              )}
            </SectionBox>

            {/* ── Module Content ── */}
            <SectionBox>
              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <Typography variant="h6" fontWeight={700} color="#1a1a2e">
                  {selectedModule ? `${selectedModule.name} — Files` : 'Module Files'}
                </Typography>
                {selectedModule && (
                  <Chip
                    label={`${selectedModule.files?.length || 0} file${selectedModule.files?.length !== 1 ? 's' : ''}`}
                    size="small"
                    sx={{ background: '#dcfce7', color: '#15803d', fontWeight: 600 }}
                  />
                )}
              </Box>
              <Divider sx={{ mb: 2.5 }} />

              {!selectedModule ? (
                <Box
                  sx={{
                    textAlign: 'center',
                    py: 6,
                    color: '#94a3b8',
                    border: '2px dashed #e2e8f0',
                    borderRadius: '12px',
                  }}
                >
                  <FontAwesomeIcon icon={faBook} style={{ fontSize: 36, marginBottom: 12, opacity: 0.4 }} />
                  <Typography fontWeight={500}>Select a module to see its files</Typography>
                </Box>
              ) : !selectedModule.files?.length ? (
                <Alert severity="info" sx={{ borderRadius: '10px' }}>
                  No files available for this module yet.
                </Alert>
              ) : (
                <Table>
                  <TableBody>
                    {selectedModule.files.map((file) => (
                      <ContentRow
                        key={file.id}
                        selected={selectedContent?.id === file.id ? 1 : 0}
                        onClick={() => handleContentClick(file)}
                      >
                        <TableCell sx={{ width: 44, pl: 2, pr: 0 }}>
                          <Box
                            sx={{
                              width: 38,
                              height: 38,
                              borderRadius: '10px',
                              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FontAwesomeIcon
                              icon={getFileIcon(file.type)}
                              style={{ color: '#fff', fontSize: 16 }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: '15px', color: '#1a1a2e' }}>
                          {file.fileName}
                        </TableCell>
                        <TableCell align="right" sx={{ pr: 2 }}>
                          <Chip
                            label={file.type?.toUpperCase() || 'FILE'}
                            size="small"
                            color={getTypeColor(file.type)}
                            sx={{ fontWeight: 700, fontSize: '11px' }}
                          />
                        </TableCell>
                      </ContentRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </SectionBox>
          </>
        )}
      </StyledPaper>

      {/* ── File Viewer Modal ── */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <ModalBox>
          {/* Modal Header */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
            pb={2}
            sx={{ borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              {selectedContent && (
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: '9px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FontAwesomeIcon
                    icon={getFileIcon(selectedContent?.type)}
                    style={{ color: '#fff', fontSize: 15 }}
                  />
                </Box>
              )}
              <Typography variant="h6" fontWeight={700} color="#1a1a2e" noWrap>
                {selectedContent?.fileName}
              </Typography>
            </Box>
            <IconButton
              onClick={handleCloseModal}
              sx={{
                background: '#f3f4f6',
                borderRadius: '10px',
                '&:hover': { background: '#fee2e2' },
              }}
            >
              <FontAwesomeIcon icon={faTimes} style={{ fontSize: 14, color: '#555' }} />
            </IconButton>
          </Box>

          {/* Modal Content */}
          <Box sx={{ flex: 1, overflow: 'hidden', borderRadius: '8px' }}>
            {selectedContent && renderContent(selectedContent)}
          </Box>
        </ModalBox>
      </Modal>
    </PageWrapper>
  );
};

// ─── Page Wrapper with Header ────────────────────────────────────────────────

const Managec = () => (
  <div>
    <Header />
    <CourseContentKey />
  </div>
);

export default Managec;

